import { forwardRef } from "react";

import { Icons } from "widgets";

import type { TileProps } from "../../../../modules/core/components/Tile.js";
import { getLastFilePathElement, getParentPath } from "../../../../modules/files/utils/file.js";
import { FILE_BROWSE_TYPES, FILE_DISPLAY_NAME } from "../../../../settings/settings.js";
import { Tile } from "@/modules/core/components/Tile.tsx";
import { TileStatus } from "@/modules/core/components/settings.ts";
import type { FileBasisFragment } from "@/modules/files/graphql/files-queries.gql.js";

interface FolderTileProps extends Pick<TileProps, "type"> {
  folder: FileBasisFragment;
}

const FolderTile = forwardRef<HTMLDivElement, FolderTileProps>(function FolderTile(props, ref) {
  const folderName: string = getLastFilePathElement(props.folder.humanReadablePath);

  return (
    <Tile
      title={folderName}
      icon={<img src={Icons.Tiles.FileBrowser} width={24} height={30} />}
      type={props.type}
      statusDisplayName={FILE_DISPLAY_NAME[FILE_BROWSE_TYPES.DIRECTORY]}
      to={props.folder.id ? `/content/files?file=${props.folder.id}` : null}
      subtitle={getParentPath(props.folder.humanReadablePath)}
      protectionStatus={
        props.folder.deleted
          ? TileStatus.Deleted
          : props.folder.hidden
            ? TileStatus.RestrictedVisibility
            : TileStatus.Normal
      }
      ref={ref}
    />
  );
});

export { FolderTile };
